import { Box, Typography } from '@mui/material';
import Container from '@mui/material/Container';
import { useNavigate } from 'react-router-dom';
import { useEffect } from 'react';
import { Helmet } from 'react-helmet';

const NoPage = ({ redirectUrl = "/"}) => {
  const navigate = useNavigate();

  useEffect(() => {
    // Redirect to home after 2 seconds
    const timer = setTimeout(() => {
      navigate(redirectUrl);
    }, 1000);

    // Clear timeout if the component is unmounted before the redirect
    return () => clearTimeout(timer);
  }, [navigate, redirectUrl]);

  return (
    <>
      <Helmet>
        <meta name="robots" content="noindex" />
      </Helmet>
      <Container
        component="main"
        maxWidth="md"
        sx={{ textAlign: 'center', py: 5 }}
      >
        <Typography variant="h3">404 Not Found</Typography>
        <Typography>Redirecting to the Home page ...</Typography>
      </Container>
    </>
  );
};

export default NoPage;
